var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFiberNewIcon = function SvgFiberNewIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0062EA",
    d: "M14.4 1.5H1.6C.712 1.5.008 2.212.008 3.1L0 12.7c0 .888.712 1.6 1.6 1.6h12.8c.888 0 1.6-.712 1.6-1.6V3.1c0-.888-.712-1.6-1.6-1.6m-9.2 8.8h-.96L2.2 7.5v2.8h-1V5.5h1l2 2.8V5.5h1zm4-3.792h-2v.896h2v1.008h-2V9.3h2v1H6V5.5h3.2zM14.8 9.5c0 .44-.36.8-.8.8h-3.2c-.44 0-.8-.36-.8-.8v-4h1v3.608h.904V6.292h1V9.1h.896V5.5h1z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFiberNewIcon);
export default ForwardRef;